import { Flex, Image } from "@mantine/core";

import logo from "/logo.png";

const Logo = () => {
  return (
    <Flex gap={0} align="center" justify="center">
      <Image height={150} src={logo} alt="Logo" />
    </Flex>
  );
};

export default Logo;
